module.exports = __webpack_public_path__ + "img/RCCN-LOGO-WHITE.43a91259.png";